export default {
  getToken: (state) => state.token,
  getEmail: (state) => state.email,
  getCustomer: (state) => state.cust_id,
  getUserInfo: (state) => state,
  getCase: (state) => state.hdcase,
  getLoginErr: (state) => state.loginErr,
  getPermission: (state) => state.permision,
  getCustName: (state) => state.cust_name,
  getIsDone: (state) => state.isDone,
  getStatus: (state) => state.status,
};